"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SUPPORTED_MAP_PROVIDER_TYPES = exports.SUPPORTED_GEOCODING_PROVIDERS = exports.PICKUP_POINT_COORDINATES_DECIMALS = exports.MapListMergeFeatureToggle = exports.MAP_MAX_ZOOM = exports.CLUSTER_SIZE_DISPLAY_LIMIT = exports.CENTER_MAP_ANIMATION_DURATION = void 0;
var _models = require("../models");
const CENTER_MAP_ANIMATION_DURATION = exports.CENTER_MAP_ANIMATION_DURATION = 500;
const CLUSTER_SIZE_DISPLAY_LIMIT = exports.CLUSTER_SIZE_DISPLAY_LIMIT = 99;
const MAP_MAX_ZOOM = exports.MAP_MAX_ZOOM = 20;
const PICKUP_POINT_COORDINATES_DECIMALS = exports.PICKUP_POINT_COORDINATES_DECIMALS = 3;
const SUPPORTED_MAP_PROVIDER_TYPES = exports.SUPPORTED_MAP_PROVIDER_TYPES = [_models.MapProviderType.Azure, _models.MapProviderType.Bing, _models.MapProviderType.Google, _models.MapProviderType.Yandex];
const SUPPORTED_GEOCODING_PROVIDERS = exports.SUPPORTED_GEOCODING_PROVIDERS = [_models.MapProviderType.Azure, _models.MapProviderType.Bing, _models.MapProviderType.Google, _models.MapProviderType.Yandex];
/* Enables merged delivery map and list search. */
const MapListMergeFeatureToggle = exports.MapListMergeFeatureToggle = 'DF9A8CDD-38AE-4D3F-909A-762E5FB5D589';